import React, { useState, useEffect } from "react";
import "./LandingPageRight.css";
function LandingPageRight() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="LandingPageRight">
      <div className="landingPageRightContainer">
        <div className="earthContainer">
          <img src="/Assets/Donation/LandingPage/earth.png" className="earthImg" alt="no img found" fetchpriority="high" />
        </div>
        <div className="landingMobileContainer">
          <div className="landingMobileContainer2">
            <div className="landingMobileContainer3">
              <img
                src="/Assets/Donation/LandingPage/mobileCont.png"
                alt="no img found"
                className="smallMobile"
              />
              <div className="landingMobileContainer4">
                <img
                  src="/Assets/Donation/LandingPage/AmalgamateVerticalLogo.png"
                  alt="no img found"
                  className="amalgamateVerticalLogo"
                />
                <img
                  src="/Assets/Donation/LandingPage/starryMob.gif"
                  alt="no img found"
                  className="starryMobile"
                />
              </div>
            </div>
            <img
              src="/Assets/Donation/LandingPage/AmalgamateMobileLarge.svg"
              alt="no img found"
              className="largerMobile"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingPageRight;
